import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ProfilService } from 'src/app/rest_services/profil.service';
import { Subscription } from 'rxjs';
import { RoleService } from 'src/app/rest_services/role.service';
import { ServiceResponse } from 'src/app/models/service-response';
import { Location } from '@angular/common';


@Component({
  selector: 'app-new-profil',
  templateUrl: './new-profil.component.html',
  styleUrls: ['./new-profil.component.css']
})
export class NewProfilComponent implements OnInit {
  newProfilForm:FormGroup;
  loadingAddingProfil:boolean = false;
  addError:any;
  htmlYouWantToAdd:any="";
  constructor(
    private formBuilder: FormBuilder,
    private profilService: ProfilService,
    private router : Router, 
    private roleService: RoleService) {
      this.newProfilForm = this.formBuilder.group({
        'label': ['', [Validators.required, Validators.minLength(5), Validators.maxLength(30), this.noSpecialCharsValidator()]],
        'description': ['', [Validators.required, Validators.minLength(5), Validators.maxLength(1000), this.noSpecialCharsValidator()]],
        'role': ['']
      });
     }

  ngOnInit(): void {
    var glob = this;
    var blocActions = this.htmlYouWantToAdd;
    $(document).ready(function() {
      $('#role').change(function() {
        var value = $(this).val();
        var elt = glob.roles.find((el:any) => el.uuid == value);
        var uuid = $("option:selected", this).attr("ud");
        var role = {
          description: $( "#role option:selected" ).text(),
          uuid: uuid
        };
        let index = -1;
        if (elt !== undefined) {
          index = glob.roles.findIndex((d :any) => d.description == elt.description);
        }
        if (index < 0 && value !== "") {
          var alreadySelected = glob.roles.some((item: any) => item.uuid === uuid);
          if (!alreadySelected) {
            const existingRole = glob.roles.find((item: any) =>
              glob.compareStringsIgnoringAccents(item.description.toString(), role.description.toString())
            );
            if (!existingRole) {
              // glob.roles.push(role);
              var insertIndex = 0;
              while (insertIndex < glob.roles.length && glob.roles[insertIndex].description < role.description) {
                insertIndex++;
              }
              // Insert the role at the correct index
              glob.roles.splice(insertIndex, 0, role);
              setTimeout(function() {
                $('#role').val("");
              }, 500);
            }
          } else {
            console.log("Role already selected!");
          }
        }
      });
    });
    this.getCompanyRoles();
  }

  noSpecialCharsValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const forbidden = /[!@#$%^&*+{}\[\]<>~\\]/.test(control.value);
      return forbidden ? { 'noSpecialChars': true } : null;
    };
  }


  refRoles: any[] = [];
  
  roles:any[]=[];

  compareStringsIgnoringAccents(str1: string, str2: string): boolean {
    if (!str1 || !str2) {return false;}
    const normalizedStr1 = str1.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const normalizedStr2 = str2.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return normalizedStr1.toLowerCase() === normalizedStr2.toLowerCase();
  }

  removeRole(Role: any) {
    const RoleIndex = this.roles.findIndex((c: any) => c.uuid === Role.uuid);
    if (RoleIndex !== -1) {
      const RoleToRemove = this.roles.splice(RoleIndex, 1)[0];
    }
  }
  
  rolesSubscription!: Subscription;
  getCompanyRoles(){
    this.rolesSubscription = this.roleService.getCompanyRoles().subscribe(
      (resp: ServiceResponse) => {
        if(resp.code == "bf025c4dcce776832c0d50903044d7f5") {
          this.refRoles = resp.roles;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  profilSubject:any;
  addedMsg:any ='';
  
  saveProfil(){
    $("html, body").animate({ scrollTop: 0 });
    this.loadingAddingProfil = true;
    if (this.newProfilForm.valid) {
      const profilData = this.newProfilForm.value;
      profilData.roles= this.roles;
      this.profilService.createProfile(profilData);
      this.profilService.newProfilSubject.subscribe((response) => {
        this.loadingAddingProfil = false;
        if (response.code == "732751139b1d911d1471c455cf15db02") {
          this.newProfilForm.reset();
          this.roles=[];
          $("#profil_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#profil_added").hide();
            this.router.navigate(["/users/fromprofiles;cs=all"])
          }, 2000);
        } else if(response.code == "893ee816fc4b5e86b0be01b3e5ed4804")  {
          this.addError =`profil `+this.newProfilForm.get('label')?.value+` existe dèja`; 
          $("#profil_not_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#profil_not_added").hide();
          }, 3000);
        } else if (response.code == "3a08a8fab9710b725e70ec53946a86c5") {
          this.addError =". Données invalides pour la création du profil"; 
          $("#profil_not_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#profil_not_added").hide();
          }, 3000);
        }else if (response.code == "68aef51ea2f67257fcf88b166f677d55") {
          this.addError =". Vous n'avez pas le droit !!"; 
          $("#profil_not_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#profil_not_added").hide();
          }, 3000);
        }
      },
      (error) => {
        console.log('profil creation error:', error);
        this.addError =". profil non ajouté"; 
          $("#profil_not_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#profil_not_added").hide();
          }, 3000);
      });
    } else {
     this.loadingAddingProfil = false;
    }
  }



}
